module.exports = "<div class=\"search-zero-results-wrapper text-center\" wow-performance-end-measure=\"search.zero result\">\r\n    <h1 class=\"search-zero-results-wrapper-header header--color-secondary\">No {{pageName}} for <span class=\"h1 header--color-primary\" ng-bind-html=\"originalSearchTerm\"></span></h1>\r\n\r\n    <div class=\"search-zero-results-wrapper-blurb\" ng-bind-html=\"EmptyProductSearchMessage\"></div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/search/search-zero-results-template.html
 ** module id = 998
 ** module chunks = 1
 **/